import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import DashboardCard from './DashboardCard';
import {
  StatValue, StatSub, SegmentBar, SegmentFill, LegendRow, LegendItem, LegendDot,
} from '../styles';

const LEVELS = ['high', 'medium', 'low'];

// FlightRiskDistribution — EmployeeFlightRisk seviye dağılımı. Seviyeler bir
// DURUM (status) anlamı taşıdığından kategorik renk yerine sabit statü renkleri
// kullanılır (dataviz kuralı — "status colors are reserved"): high→danger,
// medium→warning, low→success. Kimlik yalnız renkle taşınmaz — her segment ve
// lejant satırı metin etiketiyle (performance.talentpool.flightRisk.*, talent-
// pool/talent-reports ile AYNI anahtarlar) eşleşir.
export default function FlightRiskDistributionCard({ distribution, loading }) {
  const { t } = useTranslation();
  const theme = useTheme();

  const byLevel = distribution?.byLevel || [];
  const total = distribution?.totalCount || 0;
  const countFor = (level) => byLevel.find((b) => b.level === level)?.count || 0;

  // TD-17 — İKİLİ KİLİT'in arayüz tarafı. visibleToActor === false, "kimse riskli değil"
  // DEĞİL "bu veri size kapalı" demektir (TalentSettings.FlightRiskVisibleToManager). Boş
  // listeyi normal boş durumla göstermek, yöneticiye YANLIŞ bir güvence verirdi. Alan
  // gelmiyorsa (eski yanıt) varsayılan görünür — geriye dönük uyumlu.
  const notVisible = distribution?.visibleToActor === false;

  const LEVEL_COLOR = {
    high: theme.colors.auxiliar.danger,
    medium: theme.colors.auxiliar.warning,
    low: theme.colors.auxiliar.success,
  };

  return (
    <DashboardCard
      title={t('talent.dashboard.flightRisk.title')}
      span={4}
      spanMd={6}
      loading={loading}
      empty={notVisible || total === 0}
      emptyText={notVisible
        ? t('talent.dashboard.flightRisk.notVisible')
        : t('talent.dashboard.flightRisk.empty')}
    >
      <StatValue>{total}</StatValue>
      <StatSub style={{ display: 'block', marginBottom: 14 }}>
        {t('talent.dashboard.flightRisk.totalLabel')}
      </StatSub>

      <SegmentBar>
        {LEVELS.map((level) => {
          const count = countFor(level);
          if (count === 0) return null;
          const pct = total > 0 ? (count / total) * 100 : 0;
          return (
            <SegmentFill key={level} style={{ width: `${pct}%`, background: LEVEL_COLOR[level] }} />
          );
        })}
      </SegmentBar>

      <LegendRow>
        {LEVELS.map((level) => (
          <LegendItem key={level}>
            <LegendDot style={{ background: LEVEL_COLOR[level] }} />
            {t(`performance.talentpool.flightRisk.${level}`)} · {countFor(level)}
          </LegendItem>
        ))}
      </LegendRow>
    </DashboardCard>
  );
}
